import { cn } from '@newfront-insurance/core-ui/v2';
import { ArrowUpIcon, Paperclip } from 'lucide-react';

import { useChatOverlayContext } from '../../contexts/chat-overlay-context';

/**
 * Disabled input prompt shown in Nova Navigator when viewing an Outlook-originated chat
 * and Outlook Connect is not enabled.
 *
 * Replaces ChatInputContainer when:
 *   - currentChatAppType === 'OUTLOOK'
 *   - outlookConnectEnabled === false
 *
 * Clicking "enable Outlook Connect" opens the inline settings panel.
 */
export function OutlookConnectPrompt() {
  const { setIsSettingsOpen } = useChatOverlayContext();

  return (
    <div className="flex-shrink-0 px-2">
      <div className="mx-auto flex w-full max-w-3xl gap-2">
        <div className={cn('group relative w-full rounded-[12px] p-[2px]', 'bg-steel-200')}>
          <div className="bg-steel-50 flex w-full flex-col gap-0 overflow-hidden rounded-[10px] shadow-[0_0_0_1px_white]">
            <div className="flex min-h-[94px] items-center justify-center px-3 py-2.5">
              <p className="text-center">
                This chat was started on Outlook. To continue you have to{' '}
                <button
                  type="button"
                  onClick={() => {
                    setIsSettingsOpen(true);
                  }}
                  className="text-brand-300 cursor-pointer font-semibold underline hover:opacity-80"
                >
                  enable Outlook Connect
                </button>
              </p>
            </div>
            <div className="flex w-full flex-1 items-center p-2">
              <div className="flex flex-1">
                <button type="button" disabled aria-label="Attach file" className="cursor-not-allowed p-2 opacity-40">
                  <Paperclip size={16} />
                </button>
              </div>
              <button
                type="button"
                disabled
                aria-label="Send"
                className="h-fit cursor-not-allowed rounded-full bg-[var(--color-steel-100)] p-2 text-[var(--color-steel-200)]"
              >
                <ArrowUpIcon size={14} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
